import { ENV } from '../config/constant';
import { axios } from '../config/axios';
const { VUE_APP_API_HOST_ZLZ: HOST } = ENV;
/**
 * 登录
 * @param {password} string //密码
 * @param {userNumber} string//编号
 */
export function login({ password, userNumber } = {}) {
  return axios.post(`${HOST}/user/login`, {
    password,
    userNumber
  });
}

/**
 * 登出
 * @param {string} userUid //用户uid
 */
export function logout(userUid) {
  return axios.get(`${HOST}/user/logout`, {
    params: { userUid }
  });
}

/**
 * 添加用户
 * @param {string} nickName 昵称
 * @param {array} userRoleUids 角色列表
 */
export function addUser({ nickName, userRoleUids }) {
  return axios.post(
    `${HOST}/user/addUser`,
    {
      nickName,
      userRoleUids
    },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
}

/**
 * 批量删除用户
 * @param {array} userUids  //userUids:[0]保存需要删除的用户列表
 */
export function batchDeleteUser(userUids) {
  return axios.post(
    `${HOST}/user/batchDeleteUser`,

    userUids,
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
}

/**
 * 修改昵称
 * @param {string} nickName 用户昵称
 * @param {string} userUid 用户uid
 */
export function modifyNickName({ nickName, userUid }) {
  return axios.post(`${HOST}/user/modifyNickName`, {
    nickName,
    userUid
  });
}

/**
 * 修改用户密码
 * @param {string} userUid 用户uid
 */
export function modifyPassword({ newPassword, oldPassword, userUid }) {
  return axios.post(`${HOST}/user/modifyPassword`, {
    newPassword,
    oldPassword,
    userUid
  });
}

/**
 * 获取分页获取用户列表
 * @param {number} page 页数
 * @param {number} pageSize 条数
 * @param {number} roleType 角色
 * @param {string} searchStr 搜索框字符串
 * @param {string} sortParam 排序的指标字段
 * @param {string} sortType 排序方式
 */
export function searchUser({
  page = 1,
  pageSize = 20,
  roleType = 0,
  searchStr = '',
  sortParam = 'userNumber',
  sortType = 1
} = {}) {
  return axios.post(
    `${HOST}/user/searchUser`,
    { page, pageSize, roleType, searchStr, sortParam, sortType },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
}

/**
 * 更新用户信息
 * @param {string} nickName 昵称
 * @param {string} password 密码
 * @param {array} updateUserRoleUidList 用户角色信息表
 * @param {string} userUid 用户uid
 */
export function updateUser({
  nickName,
  password,
  updateUserRoleUidList,
  userUid
}) {
  return axios.post(
    `${HOST}/user/updateUser`,
    {
      nickName,
      password,
      updateUserRoleUidList,
      userUid
    },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
}

//获取用户校色列表
export function getUserList() {
  return axios.get(`${HOST}/role/getUserRoleList`);
}
